<template>
    <b-row>
        <b-col md="12">
            <component-header
                class="settings-page-header"
                title="Device Binding"
                :hasSearch="false"
                :hasReload="false"
                :hasCreate="false"
                :hasback="false"
            />
        </b-col>
        <b-col>
            <b-card>
                <b-row>
                    <b-col md="12" class="ml-2 mt-2 pb-0"
                        ><h4>Partners</h4></b-col
                    >
                    <b-col md="4" class="pt-0 pl-4">
                        <b-form-group class="mb-0 pt-2">
                            <b-form-checkbox
                                type="checkbox"
                                size="lg"
                                id="enableDevice_Binding"
                                value="true"
                                v-model="enableDeviceBinding"
                                @change="showDevice(0)"
                            >
                                <h4 class="m-0 font-weight-light d-inline">
                                    Enable Device Binding
                                </h4>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" v-if="enableDeviceBinding">
                        <div class="d-flex justify-content-start">
                            <b-input
                                Type="text"
                                placeholder="Enter Maximum Number Devices"
                                class="mt-0"
                                v-model="maxAllowedDevicesPartner"
                            />
                        </div>
                    </b-col>
                    <b-col md="12" class="ml-2 mt-2 pb-0 horizontal-line"
                        ><h4>Customers</h4></b-col
                    >
                    <b-col md="4" class="pt-0 pl-4">
                        <b-form-group class="mb-0 pt-2">
                            <b-form-checkbox
                                type="checkbox"
                                size="lg"
                                id="enableDevice_BindingCustomer"
                                value="true"
                                v-model="enableDeviceBindingCustomer"
                                @change="showDevice(1)"
                            >
                                <h4 class="m-0 font-weight-light d-inline">
                                    Enable Device Binding
                                </h4>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" v-if="enableDeviceBindingCustomer">
                        <div class="d-flex justify-content-start">
                            <b-input
                                Type="text"
                                placeholder="Enter Maximum Number Devices"
                                class="mt-0"
                                v-model="maxAllowedDevicesCustomer"
                            />
                        </div>
                    </b-col>

                    <b-col md="12" class="ml-2 mt-2 pb-0 horizontal-line"
                        ><h4>Agents</h4></b-col
                    >
                    <b-col md="4" class="pt-0 pl-4 mb-4">
                        <b-form-group class="mb-0 pt-2">
                            <b-form-checkbox
                                type="checkbox"
                                size="lg"
                                id="enableDevice_BindingAgent"
                                value="true"
                                v-model="enableDeviceBindingAgent"
                                @change="showDevice(2)"
                            >
                                <h4 class="m-0 font-weight-light d-inline">
                                    Enable Device Binding
                                </h4>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" v-if="enableDeviceBindingAgent">
                        <div class="d-flex justify-content-start">
                            <b-input
                                Type="text"
                                placeholder="Enter Maximum Number Devices"
                                class="mt-0"
                                v-model="maxAllowedDevicesAgent"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <b-row
                ><b-col md="3"></b-col>
                <b-col md="3" class="cancel-btn-col">
                    <b-button
                        variant="danger"
                        block
                        @click="getDeviceBindingData"
                        >CANCEL</b-button
                    ></b-col
                >
                <b-col md="3">
                    <b-button variant="primary" block @click="deviceBindingSave"
                        >SAVE</b-button
                    >
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    components: {
        profile,
        ComponentHeader,
    },
    mixins: [currentUserData],
    data() {
        return {
            currentUserData: "",
            enableDeviceBinding: false,
            enableDeviceBindingCustomer: false,
            enableDeviceBindingAgent: false,
            maxAllowedDevicesPartner: "",
            maxAllowedDevicesCustomer: "",
            maxAllowedDevicesAgent: "",
        };
    },
    computed: {
        ...mapState({
            deviceBinding: (state) => state.tenant.deviceBinding,
        }),
    },
    methods: {
        async deviceBindingSave() {
            let payload = {
                id: this.$currentUserData._id,
                binding: {
                    deviceBinding: {
                        partner: {
                            deviceBindingEnabled: this.enableDeviceBinding,
                            maxAllowedDevices: this.maxAllowedDevicesPartner,
                        },
                        customer: {
                            deviceBindingEnabled:
                                this.enableDeviceBindingCustomer,
                            maxAllowedDevices: this.maxAllowedDevicesCustomer,
                        },
                        agent: {
                            deviceBindingEnabled: this.enableDeviceBindingAgent,
                            maxAllowedDevices: this.maxAllowedDevicesAgent,
                        },
                    },
                },
            };
            await this.$store
                .dispatch("tenant/updatePreferencesTenant", payload)
                .then(() => {
                    ((this.maxAllowedDevicesPartner = ""),
                        this.$swal({
                            title: "Success",
                            text: "Allowed Devices Updated successfully!!",
                            type: "success",
                        }));
                    this.getDeviceBindingData();
                })
                .catch((err) => {
                    this.$swal({
                        title: "Opps!!!!!",
                        text: "Unable to Update Allowed Devices",
                        type: "error",
                    });
                });
        },
        showDevice(n) {
            switch (n) {
                case 0: {
                    this.maxAllowedDevicesPartner = "";
                    break;
                }
                case 1: {
                    this.maxAllowedDevicesCustomer = "";
                    break;
                }
                case 2: {
                    this.maxAllowedDevicesAgent = "";
                    break;
                }
            }
        },
        getDeviceBindingData() {
            this.$store
                .dispatch(
                    "tenant/setDeviceBindingData",
                    this.$currentUserData._id,
                )
                .then(() => {
                    this.enableDeviceBinding =
                        this.deviceBinding.partner.deviceBindingEnabled;
                    this.maxAllowedDevicesPartner =
                        this.deviceBinding.partner.maxAllowedDevices;
                    this.enableDeviceBindingCustomer =
                        this.deviceBinding.customer.deviceBindingEnabled;
                    this.maxAllowedDevicesCustomer =
                        this.deviceBinding.customer.maxAllowedDevices;
                    this.enableDeviceBindingAgent =
                        this.deviceBinding.agent.deviceBindingEnabled;
                    this.maxAllowedDevicesAgent =
                        this.deviceBinding.agent.maxAllowedDevices;
                });
        },
    },
    mounted() {
        this.getDeviceBindingData();
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },
};
</script>
<style scoped>
.settings-page-header {
    margin-top: 0;
}

:deep(.settings-page-header .component-header-navbar) {
    padding-top: 0;
}

.language-button button {
    width: 160px;
    margin-bottom: 15px;
    margin-left: 15px;
    margin-right: 15px;
    font-size: 14px;
}
@media (max-width: 768px) {
    .language-button button {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
}
.horizontal-line {
    border-top: 1.5px dashed #d8e1e7;
}
@media (max-width: 768px) {
    .cancel-btn-col {
        margin-bottom: 10px;
    }
}
</style>
